// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"28":"91c64d7f","87":"13ff5717","121":"d036fb6b","194":"1a86a742","508":"aacdd358"}[chunkId] + ".css";
};